const CAMILLE_REBUY_TIERS = [
  {
    min: 50,
    type: 'shipping',
    icon: '🎁',
    message: 'Add $$ to unlock a free gift',
    products: [
      6928362078283 // Surprise Travel Tube Glycerine Hand Therapy
    ]
  },
  {
    min: 75,
    type: 'shipping',
    icon: '🚚',
    message: 'Add $$ to unlock free shipping'
  },
  //{
//    min: 100,
  //  type: 'product',
 //   icon: '🎁',
 //   message: 'Add $$ to unlock more free gift options',
 //   products: [
 //     6844148842571 // Creamy Candy - Hand + Body Cream
 //   ]
 // },
  // {
  //   min: 125,
  //   type: 'product',
  //   icon: '➕',
  //   message: 'Add $$ to unlock more free gift options',
  //   products:[
  //     6672475652171, // Glycerine Hand Therapy 60z Love Sprinkles
  //   ]
  // },
//  {
//    min: 150,
//    type: 'product',
//    icon: '➕',
//    message: 'Add $$ to unlock more free gift options',
//    products:[
//      6893179830347 // Camille Bone China Mug - Green
//    ]
//  },
//  {
//    min: 175,
//    type: 'product',
//    icon: '➕',
//    message: 'Add $$ to unlock more free gift options',
//    products:[
//      6928376528971 // 5 Mini Wellness Balms + Bath Soak Bundle 
//    ]
//  },
//  {
//    min: 200,
//    type: 'product',
//    icon: '➕',
//    message: 'Add $$ to unlock more free gift options',
//    products:[
//      6812811460683 // The Romance Collection Glycerine Hand Therapy™ 1.35oz Travel Tube Gift Set
//    ]
//  }
];

const CAMILLE_REBUY_CONFIG = {
  GIFT_WRAPPING_VARIANT_ID: 6106595268,
  GIFT_WRAPPING_TEXT: "🎁 Add Gift Wrapping $7.95",
  PRODUCT_LIST_TITLE: "You've unlocked a Free Gift!",
  PROGRESS_COMPLETED_MESSAGE: "You've unlocked Free Shipping + A Free Gift!",
  FREE_GIFT_COLLECTION_HANDLE: "free-gifts-with-purchase",
};